module.exports = __webpack_public_path__ + "img/w3_chevron_up_white.0ed03193.0ed03193.png";